import React from "react";
import clsx from "clsx";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography/Typography";
import CustomDialog from "../Shared/Components/CustomDialog";
import MainButton from "../Shared/Components/MainButton";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(
  () => ({
    dialogContentRoot: {
      padding: "0 24px 24px 12px",
    },
    actionButton: {
      padding: "4px 15px",
      textDecoration: "none",
      "&.inactive": {
        opacity: 0.4,
      },
    },
    TypographyCaption: {
      fontSize: 12,
      lineHeight: 1.7,
    },
  }),
  { name: "ConfirmationDialog" }
);

const ConfirmationDialog = (props) => {
  const classes = useStyles(props);
  const { t } = useTranslation(["common"]);
  const { show, onCancel, content, onConfirm } = props;
  return (
    <CustomDialog
      open={show}
      onCancel={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent className={classes.dialogContentRoot}>
        <Typography
          variant="body1"
          classes={{ root: classes.TypographyCaption }}
          id="alert-dialog-description"
        >
          {content}
        </Typography>
      </DialogContent>
      <DialogActions>
        <MainButton
          onClick={onCancel}
          variant="contained"
          className={clsx(classes.actionButton, "inactive")}
          labelColor="#000000"
        >
          {t("common:cancel")}
        </MainButton>
        <MainButton
          onClick={onConfirm}
          variant="contained"
          className={clsx(classes.actionButton, "primaryButton")}
        >
          {t("common:apply")}
        </MainButton>
      </DialogActions>
    </CustomDialog>
  );
};

export default ConfirmationDialog;
